import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm} from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as backInter from 'app/auth/auth-data.model';

//SERVICE
import { RequirementsService } from "../services/requirements.service";

@Component({
  selector   : 'requirements',
  templateUrl: './requirements.component.html',
  styleUrls  : ['./requirements.component.scss'],
  animations : fuseAnimations
})
export class RequirementsComponent implements OnInit
{

  form: FormGroup;
  idEmpresa: any;
  show: boolean = false;
  datos: backInter.getITInfo;
  // datos = {
  //   'nombreCompleto' : '',
  //   'apellido' : '',
  //   'correoElectronico' : '',
  //   'telefonoOficina' : '',
  //   'extension' : '',
  //   'celular' : ''
  // };

  constructor(private _formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private activatedRoute : ActivatedRoute,
    private service : RequirementsService,
    private router: Router,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ){

    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];

      this.getManager();

    });

    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.form = this._formBuilder.group({
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])],
      phone: ['', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.pattern('[0-9]+')])],
        ext: ['', Validators.required],
        cellphone: ['', Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.pattern('[0-9]+')])]
        });
      }

      private getManager(){

        this.service.getManagerTI(this.idEmpresa)
        .subscribe((response:backInter.getITInfo) => {
          console.log(response);
          if(response.success){
            this.datos = response;
            this.form.get('name').disable();
            this.form.get('lastname').disable();
            this.form.get('email').disable();
            this.form.get('phone').disable();
            this.form.get('ext').disable();
            this.form.get('cellphone').disable();
          }
          // if(response.hasOwnProperty('datosResponsable')){
          //   this.datos = response['datosResponsable'];
          //
          //   //console.log(this.datos);
          //   this.form.get('name').disable();
          //   this.form.get('lastname').disable();
          //   this.form.get('email').disable();
          //   this.form.get('phone').disable();
          //   this.form.get('ext').disable();
          //   this.form.get('cellphone').disable();
          //
          //   this.show = false;
          //
          // }else{
          //   this.show = true;
          // }


        }, error => {
          //console.log(error);
        });

      }

      private registerManager(){
        let name = this.form.value.name;
        let lastname = this.form.value.lastname;
        let email = this.form.value.email;
        let phone = this.form.value.phone;
        let ext = this.form.value.ext;
        let cellphone = this.form.value.cellphone;

        if (this.form.valid) {
          let data={
            'nombreCompleto' : name,
            'apellido' : lastname,
            'correoElectronico' : email,
            'telefonoOficina' : phone,
            'extension' : ext,
            'celular' : cellphone
          };

          this.service.registerManagerTI(this.idEmpresa,data)
          .subscribe(response => {

            if(response['message'] == 'Success'){
              this.openSuccessSnackBar('User registered successfully','OK');
              this.router.navigate(['/companies']);
            }else{
              this.openSnackBar('Error, the user could not register please try again','OK');
            }

          }, error => {
            //console.log(error);
          });
        }else{
          //console.log('Por favor, complete los datos');
          this.openSnackBar('Please fill in the information.','OK');
        }
      }

      public isValid(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
          duration: 60000,
          verticalPosition: 'top',
          panelClass: ['background-red']
        });
      }


      openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
          duration: 60000,
          verticalPosition: 'top',
          panelClass: ['background-success']
        });
      }

    }
